import React, { Component } from 'react';
import Moment from 'moment';
import { Dialog, Table, TableHead, TableRow, TableCell, TableBody, Grid, Box, Button } from '@material-ui/core';
import PopUp from '../../../commonModules/interface/PopUp';

import InputText, { InputSelect } from '../../../commonModules/interface/form-input-inline';
import {TextField} from '@material-ui/core';
import { toast } from 'react-toastify';

var $ = require('jquery');

class StatusList extends Component {
    state = {
        boxSwitchList: [],
        newBoxList: [{id:"",value:""},{id:"O",value:"toto"}],
        linkedBoxList: [{id:"",value:""},{id:"O",value:"titi"}],
        name: '',
        newBoxName: '',
        oldBoxName: '',
        title: '',
        toModify: '',
        add: false,
        edit: false,
        loading: false,
    };
     componentDidMount= async() => {
        var methodName = "componentDidMount / StatusList"
        try {
            //Collect Old boxSwitch List
            var urlAllChange = "/box/changed?status=switched";

            this.serverRequest1 = $.get(urlAllChange, function(result) {
                console.log('[INFO],  reception des données  des associations de PAYGO ');
                console.log(result);
                var optionTmp = [];
                try {
                    var data = result; //var data = JSON.parse(result);

                    for (var i = 0; i < data.content.length; i += 1) {
                        optionTmp.push({date: data.content[i].date ,old: data.content[i].old,new: data.content[i].new})
                    }
                } catch (e) {
                    // les instructions utilisées pour gérer les
                    // exceptions
                    console.log('[ERROR], ', methodName, ',Parsing data from serveur ');
                    console.log(e); // on transfère l'objet de l'exception à une méthode
                    return;
                }
                optionTmp = this.orderName(optionTmp);
                this.setState({boxSwitchList: optionTmp});
            }.bind(this));

            //Collect Box List to link to a user
            var urlBoxLinkToUser = "/box/list?status=linked";

            this.serverRequest2 = $.get(urlBoxLinkToUser, function(result) {
                console.log('[INFO],  reception des données  des associations de PAYGO ');
                console.log(result);
                var optionTmp = [];
                optionTmp.push({id: "",value:"",})
                try {
                    var data = result; //var data = JSON.parse(result);

                    for (var i = 0; i < data.content.length; i += 1) {
                        optionTmp.push({id: data.content[i].idBox,value: data.content[i].idBox})
                    }
                } catch (e) {
                    // les instructions utilisées pour gérer les
                    // exceptions
                    console.log('[ERROR], ', methodName, ',Parsing data from serveur ');
                    console.log(e); // on transfère l'objet de l'exception à une méthode
                    return;
                }
                optionTmp = this.orderName(optionTmp);
                this.setState({linkedBoxList: optionTmp, boxlistValue: ""});
            }.bind(this));

            //Collect Box List linked to an installation/user
            var urlBoxFreeOfAssociation = "/box/list?status=configured";

            this.serverRequest3 = $.get(urlBoxFreeOfAssociation, function(result) {
                console.log('[INFO],  reception des données  des associations de PAYGO ');
                console.log(result);
                var optionTmp = [];
                optionTmp.push({id: "",value:"",})
                try {
                    var data = result; //var data = JSON.parse(result);

                    for (var i = 0; i < data.content.length; i += 1) {
                        optionTmp.push({id: data.content[i].idBox,value: data.content[i].idBox})
                    }
                } catch (e) {
                    // les instructions utilisées pour gérer les
                    // exceptions
                    console.log('[ERROR], ', methodName, ',Parsing data from serveur ');
                    console.log(e); // on transfère l'objet de l'exception à une méthode
                    return;
                }
                optionTmp = this.orderName(optionTmp);
                this.setState({newBoxList: optionTmp, boxlistValue: ""});
            }.bind(this));

        } catch (err) {
            console.log(err);
        }
    }
    orderName = (info) =>{
        info.sort(function(a, b) {
            if (a.value>b.value){
              return -1;
            }
            if (a.value < b.value){
              return 1;
            }
            return 0;
        });
        return info;
    }
    onSubmit = async () => {
        console.log('[DEBUG], Click on Submit, switch Box,');
        this.setState({loading: true})
        //Push request on back End
        let payload = {
            oldBox: this.state.oldBoxName,
            newBox: this.state.newBoxName,
        };
        let body = "";
        const response = await fetch('/box/switchBox', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                //'X-CSRF-Token': document.getElementsByName("_csrf")[0].content
            },
            body: JSON.stringify(payload),
            credentials: 'same-origin'
        })
        body = await response.json();
        console.log(body);
        if (body.content !== "OK") {
            console.log('[ERROR],onSubmit,SwitchBox',body.content)
            let errorMsg = body.content ? body.content : body.error.error
            if (errorMsg.length > 120) {
                errorMsg = errorMsg.slice(0, 120) + "..."
            }
            toast.error(  errorMsg)
            this.setState({loading: false})
            return;
        } else {
            if (this.state.add) {
                toast.success( "Box modifié")
                this.setState({
                    add: false,
                    oldBoxName: '',
                    newBoxName: '',
                    linkedBoxList: this.orderName([...this.removeFromList(this.state.linkedBoxList,this.state.oldBoxName),{id: this.state.newBoxName,value: this.state.newBoxName}]),
                    newBoxList: this.orderName([...this.removeFromList(this.state.newBoxList,this.state.newBoxName),{id: this.state.oldBoxName,value: this.state.oldBoxName}]),
                    boxSwitchList: [...this.state.boxSwitchList, {date: Moment().format("MMM Do YY") ,old: this.state.oldBoxName, new: this.state.newBoxName, }],
                    loading: false
                });
            } 
        }
    }
    removeFromList(list,element){
        for (var i = list.length; i--;) {
            if (list[i].id === element) {
                console.log('[DEBUG],removeFromList,',element)
                list.splice( i, 1);
            }
        }
        return list;
    }
    render() {
        let linkedBoxList = [];
        this.state.linkedBoxList.map((zone)=>(
            linkedBoxList.push({label: zone.id, value: zone.value})
            )) 
        return (
            
            <PopUp
                title="Liste des changements de box"
                close={this.props.onCloseOverlay}
                // submitAction={() => this.setState({ add: true })}
                // submitTitle="Nouveau"
                scroll="paper"
            >
                { this.state.add &&
                <PopUp
                    title="Changement Box"
                    submitAction={this.onSubmit}
                    close={ () => this.setState({  add: false })}
                    maxWidth="sm"
                    disabledSubmit={this.state.loading}
                >
                    {/* <Grid container spacing={2}>
                        <Grid item xs={12} sm={6}> */}
                            {/* <p class="c-black f-500 m-b-20">Numéro ancienne Box</p> 
                            <div className="form-group">
                                <div className='fg-line'>
                                    <select className="search-field form-control" value={this.state.oldBoxName} onChange={(e) => this.setState({ oldBoxName: e.target.value })}>
                                        {this.state.linkedBoxList.map( (optionval) => 
                                            <option value={optionval.id}>{optionval.value}</option>
                                        )}
                                        </select>
                                </div>
                            </div> */}
                            <InputSelect
                                options={linkedBoxList}
                                className="form-control"
                                name="oldBoxName"
                                value={this.state.oldBoxName} 
                                placeholder="Numéro ancienne Box"
                                label="Numéro ancienne Box"
                                onChange={(e) => this.setState({ oldBoxName: e.value })}
                            />
                        {/* </Grid>

                        <Grid item xs={12} sm={6}> */}
                            {/* <p class="c-black f-500 m-b-20">Numéro nouvelle Box</p>
                            <div className="form-group">
                                <div className='fg-line'>
                                    <input className="search-field form-control" value={this.state.newBoxName} onChange={(e) => this.setState({ newBoxName: e.target.value })}/>
                                </div>
                            </div> */}
                            <InputText
                                // style={{width:"100%"}}
                                // margin="normal"
                                // variant="outlined"  
                                value={this.state.newBoxName}
                                placeholder="Numéro nouvelle Box"
                                label="Numéro nouvelle Box"
                                onChange={(e) => {this.setState({newBoxName:e.target.value})}}
                            />
                        {/* </Grid>
                    </Grid> */}
                </PopUp>
                }
                <Box style={{textAlign: "right"}}>
                    <Button variant="contained" color="secondary" onClick={ () => this.setState({ add: true }) }> 
                        Nouveau
                    </Button>
                </Box>
                <div className="table-responsive">
                    { this.state.boxSwitchList.length === 0 && 
                        <h4 style={{ textAlign: 'center', marginBottom: '15px' }}>Vous n'avez pas changé de box</h4> 
                    }
                    { this.state.boxSwitchList.length !== 0 &&
                    <Table className="table" style={{ marginBottom: '15px' }}>
                        <TableHead>
                            <TableRow>
                                <TableCell>Date</TableCell>
                                <TableCell>Nom Ancienne Box</TableCell>
                                <TableCell>Nom Nouvelle Box</TableCell>
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            { this.state.boxSwitchList.map(status => 
                                <TableRow>
                                    <TableCell style={{ maxWidth: '70%' }}>{status.date}</TableCell>
                                    <TableCell style={{ maxWidth: '70%' }}>{status.old}</TableCell>
                                    <TableCell style={{ maxWidth: '70%' }}>{status.new}</TableCell>
                                </TableRow>
                            )}
                        </TableBody>
                    </Table>
                    }
                    {/* <div
                        className="btn-float"
                        style={{ width: '100px', height: '50px', background: 'white', display:'flex', justifyContent: 'center', alignItems: 'center', borderRadius: '0px 0px 50px 50px', right: 'calc(50% - 50px)' }}
                    >
                        <button
                            className="btn bgm-lightgreen btn-float waves-effect waves-circle waves-float"
                            style={{ width: '60px', height: '60px', top: '-50%' }}
                            onClick={() => this.setState({ add: true })}
                        >
                            <i className="zmdi zmdi-plus" style={{ fontSize: '27px', display: 'block' }}></i>
                        </button>
                    </div> */}
                </div>

                
            </PopUp>
        );
    }
}

export default StatusList

